<div class="SetVariables">
  <div class="PrefsPipeline-header d-flex flex-row justify-content-between">
    <h4>Update Campaign Variables</h4>
    <app-button
      [style]="'outline'"
      size="small"
      color="blue"
      text="Back to Inbox"
      route="/messages"></app-button>
  </div>

  <div *ngIf="formReady" class="etVariables-form">
    <form [formGroup]="formGroup">
      <div class="SetVariables-form-row">
        <div class="SetVariables-form-label col col-12 col-md-6">
          <p class="mb-0">Variable1:</p>
        </div>
        <div class="col col-12 col-md-6">
          <app-text-field
            placeholder="Variable 1"
            formControlName="label1"></app-text-field>
        </div>
      </div>
      <div class="SetVariables-form-row">
        <div class="SetVariables-form-label col col-12 col-md-6">
          <p class="mb-0">Variable2:</p>
        </div>
        <div class="col col-12 col-md-6">
          <app-text-field
            placeholder="Variable 2"
            formControlName="label2"></app-text-field>
        </div>
      </div>
      <div class="SetVariables-form-row">
        <div class="SetVariables-form-label col col-12 col-md-6">
          <p class="mb-0">Variable3:</p>
        </div>
        <div class="col col-12 col-md-6">
          <app-text-field
            placeholder="Variable 3"
            formControlName="label3"></app-text-field>
        </div>
      </div>
    </form>
    <div class="d-flex flex-row justify-content-between mt-5">
      <app-button
        class="ChangePassword-form-button"
        [style]="updateButtonProperties.style"
        [size]="updateButtonProperties.size"
        [color]="updateButtonProperties.color"
        [text]="updateButtonProperties.text"
        [observeApi]="true"
        [Click]="updateButtonProperties.onClick"></app-button>
    </div>
  </div>
</div>
